<template functional>
    <div>
        <translate path="Cancellation.success.text" tag="p"/>

        <translate path="Cancellation.contact" tag="p">
            <template v-slot:phone>
                <strong>{{props.supportPhone}}</strong>
            </template>
            <template v-slot:email>
                <strong>{{props.supportEmail}}</strong>
            </template>
        </translate>

        <div class="text-center">
            <nuxt-link to="/" class="btn btn-primary text-uppercase">
                {{parent.$t('Generic.toStartPage')}}
            </nuxt-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SuccessText',
        props: {
            supportPhone: String,
            supportEmail: String
        }
    }
</script>

<style scoped>

</style>
